import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  ExternalIdPasswordCredentialRequest,
  createExternalIdPasswordCredential,
  getExternalIdPasswordCredentials,
  deleteExternalIdPasswordCredential,
} from '~apis/external-credential';

// Query Keys
const externalCredentialQueryKeys = {
  all: ['external-credentials'] as const,
  byCompany: (companyId: string) => [...externalCredentialQueryKeys.all, companyId] as const,
  crefia: (companyId: string) =>
    [...externalCredentialQueryKeys.byCompany(companyId), 'crefia'] as const,
};

// Hooks
export const useGetExternalIdPasswordCredentials = (companyId: string) => {
  return useQuery({
    queryKey: externalCredentialQueryKeys.byCompany(companyId),
    queryFn: () => getExternalIdPasswordCredentials(companyId),
    enabled: !!companyId,
  });
};

export const useCreateExternalIdPasswordCredential = (companyId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: ExternalIdPasswordCredentialRequest) =>
      createExternalIdPasswordCredential(companyId, request),
    onSuccess: () => {
      // 연결 목록 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: externalCredentialQueryKeys.all,
      });
    },
  });
};

export const useDeleteExternalIdPasswordCredential = (companyId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (credentialId: number) =>
      deleteExternalIdPasswordCredential(companyId, credentialId),
    onSuccess: () => {
      // 연결 목록 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: externalCredentialQueryKeys.all,
      });
    },
  });
};
